"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Content = void 0;
var _contexts = require("../../../../contexts");
var _constants = require("../../constants");
var _ContentRows = require("../ContentRows");
var _ProductsLoading = require("../ProductsLoading");
var _styles = require("./styles");
var _jsxRuntime = require("react/jsx-runtime");
const Content = ()=>{
    const { isRefreshing } = (0, _contexts.useBannerProductListingContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_styles.Root, {
        children: isRefreshing ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ProductsLoading.ProductsLoading, {
            items: _constants.PAGINATION_LIMIT_ITEMS
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_ContentRows.ContentRows, {})
    });
};
exports.Content = Content;
